import { endsWith, forOwn } from 'lodash'
import { showErrorNotification, showSuccessNotification } from '../../../toastr'
import IGNORED_ENDPOINTS from './ignore'

function ignoreEndpoint(url) {
  let ignore = false
  IGNORED_ENDPOINTS.forEach(endpoint => {
    if (endsWith(url, endpoint)) {
      ignore = true
    }
  })
  return ignore
}

export function success(response) {
  const { config } = response
  const { url, method } = config
  if (ignoreEndpoint(url)) return response

  switch (method) {
    case 'post':
      showSuccessNotification('Cadastro realizado com sucesso!')
      break
    case 'put':
      showSuccessNotification('Cadastro alterado com sucesso!')
      break
    case 'delete':
      showSuccessNotification('Cadastro removido com sucesso!')
      break
  }

  return response
}

export function error(err) {
  const { response, config } = err
  const { status, data } = response
  const { url } = config
  const { message, ModelState } = data

  if (ignoreEndpoint(url)) return Promise.reject(err)

  if (status === 401) {
    window.vue.$router.push('/login')
    return Promise.reject(err)
  }

  if (message) {
    showErrorNotification(message)
  } else {
    if (ModelState) {
      forOwn(ModelState, validation => {
        validation.forEach(showErrorNotification)
      })
    } else {
      showErrorNotification('Ocorreu um erro!')
    }
  }

  return Promise.reject(err)
}
